import React, {
  useEffect,
  useRef,
  // useRef,
  useState,
} from "react";
import {
  Avatar,
  Box,
  Button,
  Container,
  //Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  //ListItemAvatar,
  ListItemButton,
  // ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  // Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
//* Fecha formato
import { format } from "date-fns";
import bdService from "../../../services/maestros.service";
import bdBodega from "../../../services/bodega.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack"; //Para alertas notificaciones
//****** iconos */
import LocalShippingTwoToneIcon from "@mui/icons-material/LocalShippingTwoTone";
import EventNoteTwoToneIcon from "@mui/icons-material/EventNoteTwoTone";
import styled from "@emotion/styled";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

// numero
const CustomTextField13R = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "right",
    fontSize: "13px", // Ajusta el tamaño de fuente aquí
  },
});
const CustomTextField13L = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "left",
    fontSize: "13px", // Ajusta el tamaño de fuente aquí
  },
});

//cantidad
const CustomTextFieldCnt = styled(TextField)({
  "& .MuiInputBase-input": {
    textAlign: "right",
    fontSize: "20px", // Ajusta el tamaño de fuente aquí
  },
});

// eslint-disable-next-line
const IPropslabel20px = {
  style: {
    color: "green",
    fontSize: "20px",
    textAlign: "right",
  },
};
// eslint-disable-next-line
const IPropslabel10px = {
  style: {
    color: "blue",
    fontSize: "10px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel11px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel12px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel13px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel14px = {
  style: {
    color: "blue",
    fontSize: "12px",
    textAlign: "center",
  },
};
// eslint-disable-next-line
const IPropslabel15px = {
  style: {
    color: "blue",
    fontSize: "15px",
    textAlign: "center",
  },
};

// eslint-disable-next-line
const IPropsNumerico = {
  inputMode: "numeric",
  maxLength: 15,
};

const Entregas = () => {
  const { enqueueSnackbar } = useSnackbar();

  //********** Sucursal ******************************/
  const [sucursales, setSucursales] = useState([]);
  const [bSeleccionada, setbSeleccionada] = useState(false);
  const [NomBodega, setNomBodega] = useState(null);
  const [SucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [BodegaSeleccionada, setBodegaSeleccionada] = useState("");
  //**************************************** */
  const [datalistMonitor, setdatalistMonitor] = useState([]);
  const [datadetalle, setdatadetalle] = useState([]);
  const [bSeleccionDesRes, setbSeleccionDesRes] = useState(false);
  const [bMostarListado, setbMostarListado] = useState(false);
  const [isDesRes, setDesRes] = useState("");
  const [bScanResDes, setbScanResDes] = useState(false);
  //**************************************** */
  /* Datos Seleccionados */
  //**************************************** */
  const [iNumero, setNumero] = useState(0);
  // const [sFecha, setFecha] = useState("");
  const [sReferencia, setReferencia] = useState("");
  //**************************************** */
  const [bMostrarDato, setbMostrarDato] = useState(false);
  const [iMostrarCantidad, setiMostrarCantidad] = useState(0);
  const [iMostrarStk, setiMostrarStk] = useState(0);
  // const [iMostrarEntregado, setiMostrarEntregado] = useState(0);
  // const [iMostrarNoEntregado, setiMostrarNoEntregado] = useState(0);
  const [iMostrarPendiente, setiMostrarPendiente] = useState(0);
  const [sMostrarDescripcion, setsMostrarDescripcion] = useState("");
  const [sMostrarCodigo, setsMostrarCodigo] = useState("");
  //**************************************** */
  // Redux
  //**************************************** */
  const { usuario } = useSelector((state) => state.user);
  //*************************************** */
  const ScanBarraRef = useRef(null);
  // ********************************************************** */
  // ****************** Llenado Sucursal ********************** */
  // ********************************************************** */
  const Limpiar = () => {
    //********** Sucursal ******************************/
    setbSeleccionada(false);
    setNomBodega("");
    setSucursalSeleccionada(null);
    setBodegaSeleccionada("");
    setdatalistMonitor([]);
    setdatadetalle([]);
    setbSeleccionDesRes(false);
    setbMostarListado(false);
    setDesRes("");
    setbScanResDes(false);
    setNumero(0);
    setReferencia("");
    setbMostrarDato(false);
    setiMostrarCantidad(0);
    setiMostrarStk(0);
    setiMostrarPendiente(0);
    setsMostrarDescripcion("");
    setsMostrarCodigo("");
  };

  const CargarBodegas = async () => {
    try {
      const iSucursal =
        parseInt(usuario.TipoUsuario) <= 1 ? -1 : usuario.Sucursal;
      const datos = await bdService.Bodegas(iSucursal, "A");
      if (datos.status === 200) {
        // Llenado
        setSucursales(datos.data.Sucursales);
        if (parseInt(usuario.TipoUsuario) <= 1) {
          //******** Seleccionar una sucursal */
          setbSeleccionada(false);
        } else {
          if (datos.data.Sucursales.length === 1) {
            //******** Asignando datos de la bodega automaticamente */
            setNomBodega(datos.data.Sucursales[0].Nombre);
            setSucursalSeleccionada(datos.data.Sucursales[0].Sucursal);
            setBodegaSeleccionada(datos.data.Sucursales[0].Bodega);
            setbSeleccionada(true);
            setbSeleccionDesRes(true);
          } else {
            //******** Seleccionar una sucursal */
            setbSeleccionada(false);
          }
        }
      } else if (datos.status === 400) {
        // Esta mal
        // console.log(datos);
      }
    } catch (error) {
      // Manejo del error si ocurre
      console.log(error);
    }
  };
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    Limpiar();
    CargarBodegas();
  }, []);

  //********************* Combo sucursal */
  const handleChangeComboBox = async (event) => {
    const nombreSeleccionado = event.target.value;
    const SucBodSelect = sucursales.find(
      (sucursal) => sucursal.Nombre === nombreSeleccionado
    );
    setSucursalSeleccionada(SucBodSelect.Sucursal);
    setBodegaSeleccionada(SucBodSelect.Bodega);
    setNomBodega(nombreSeleccionado);
    setbSeleccionada(true); //cambia a seleccionada a true para continuar
    setbSeleccionDesRes(true); // Para que aparezca los botones de Despacho y Reserva
  };

  //*********************************************************** */
  //**************** Consultando al CodigoBarra */
  //*********************************************************** */
  const handleKeyDownCodBarra = (event) => {
    if (event.key === "Enter") {
      var CodigoBarra_value = event.target.value;
      var _CodigoBarra;
      if (CodigoBarra_value === null) {
        _CodigoBarra = "*";
      } else {
        _CodigoBarra = CodigoBarra_value.padStart(15, "*");
      }
      // alert(_CodigoBarra);
      const resultado = datadetalle.find(
        (item) => item.CodigoBarra === _CodigoBarra
      );
      // console.log(datadetalle);
      if (resultado) {
        if (resultado.Pendiente === 0) {
          enqueueSnackbar(`Este item se encuentra ya preparado...`, {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
          return;
        }
        /*************************************************** */
        setiMostrarCantidad(resultado.Cantidad);
        setsMostrarDescripcion(resultado.Nombre);
        setsMostrarCodigo(resultado.Codigo);
        setiMostrarStk(resultado.Stock);
        setiMostrarPendiente(resultado.Pendiente);
        /*************************************************** */
        setbMostrarDato(true);
      } else {
        enqueueSnackbar(
          `No se encuentra este código de barra dentro del documento`,
          {
            variant: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          }
        );
      }
      event.target.value = "";
      setTimeout(() => {
        ScanBarraRef.current.focus();
      }, 500);
    }
  };

  //*********************************************************** */
  // Botones
  //*********************************************************** */
  const DatosMonitor = async (cModo) => {
    try {
      let sEstado = cModo === "R" ? "N" : "E";
      const response = await bdBodega.dsMonitor(
        cModo,
        SucursalSeleccionada,
        BodegaSeleccionada,
        sEstado
      );
      if (response.status === 200) {
        setdatalistMonitor(response.data.monitor);
        setbSeleccionDesRes(false);
        setDesRes(cModo);
        setbMostarListado(true);
      } else {
        enqueueSnackbar(`Error en extración de datos ${response.data.msg}`, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      console.error(error);
      console.log("Error ", error);
    }
  };
  const onClickDespacho = () => {
    DatosMonitor("D");
  };

  const onClickReserva = () => {
    DatosMonitor("R");
  };

  const onClickLista = async (valor) => {
    try {
      let response;
      if (isDesRes === "R") {
        response = await bdBodega.dsresbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          valor.Numero
        );
      } else {
        response = await bdBodega.dsdesbodegadet(
          SucursalSeleccionada,
          BodegaSeleccionada,
          valor.Numero
        );
      }
      if (response.status === 200) {
        let datos;
        if (isDesRes === "D") {
          datos = response.data.desbodegadet;
        } else {
          datos = response.data.resbodegadet;
        }
        setdatadetalle(datos);
        setbMostarListado(false);
        setbScanResDes(true);
        setNumero(valor.Numero);
        setReferencia(valor.Referencia);
        setTimeout(() => {
          ScanBarraRef.current.focus();
        }, 300);
      }
    } catch (error) {
      enqueueSnackbar(`Error try ${error}`, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
    }
  };
  const onClickVolver = () => {
    setbMostarListado(false);
    setbSeleccionDesRes(true);
    setbScanResDes(false);
    setbMostrarDato(false);
    //   setTimeout(() => {
    //     ScanBarraRef.current.focus();
    //   }, 200);
  };

  //  const onClick = () => {};

  const onClickListado = () => {
    setbScanResDes(false);
    setbMostarListado(true);
    setbMostrarDato(false);
  };
  //*********************************************************** */
  return (
    <div>
      <Container maxWidth="sm md xs">
        <Container maxWidth="sm md xs" sx={{ mt: 1 }}></Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <Box
              borderRadius="8px"
              sx={{ boxShadow: 1, backgroundColor: "#FFFFFF", height: "auto" }}
            >
              {!bSeleccionada ? (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Entregas de Bodega
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Select
                      value={BodegaSeleccionada} // we want to work in controlled mode
                      displayEmpty
                      fullWidth
                      onChange={handleChangeComboBox} // we want to work in controlled mode
                    >
                      <MenuItem value="" disabled>
                        Sucursales
                      </MenuItem>
                      {sucursales?.map((option) => {
                        return (
                          <MenuItem key={option.Nombre} value={option.Nombre}>
                            {option.Nombre ?? option.value}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={1} sx={{ p: 1 }}>
                  <Grid item xs={12} md={12} sm={12}>
                    <Box sx={{ color: "text.secondary", textAlign: "center" }}>
                      Entregas de Bodega {NomBodega}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Box>
          </Grid>
        </Grid>
        {bSeleccionada && bSeleccionDesRes && (
          <>
            <Grid container spacing={0} sx={{ mt: 1 }}>
              <Grid item xs={12} md={12} sm={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 4,
                    display: "flex",
                    justifyContent: "center", // Centra los elementos horizontalmente
                    alignItems: "center", // Centra los elementos verticalmente
                  }}
                >
                  <Grid item xs={12} md={6} sm={6}>
                    <Stack spacing={1} direction="column">
                      <Button
                        variant="contained"
                        startIcon={<LocalShippingTwoToneIcon />}
                        onClick={onClickDespacho}
                      >
                        Despacho
                      </Button>
                      <Button
                        variant="contained"
                        startIcon={<EventNoteTwoToneIcon />}
                        onClick={onClickReserva}
                      >
                        Reserva
                      </Button>
                    </Stack>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
        {bMostarListado && (
          <>
            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} md={12} sm={12}>
                <Box
                  borderRadius={"8px"}
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    color: "text.secondary",
                    p: 1,
                    maxWidth: "100%",
                    textAlign: "right",
                  }}
                >
                  <IconButton onClick={onClickVolver}>
                    <Avatar sx={{ backgroundColor: "green" }}>
                      <ListAltIcon />
                    </Avatar>
                  </IconButton>
                </Box>
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} md={12} sm={12}>
                <Box
                  borderRadius="8px"
                  sx={{
                    boxShadow: 1,
                    backgroundColor: "#FFFFFF",
                    height: "auto",
                    p: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <List aria-label="contacts">
                    {datalistMonitor.map((item, index) => (
                      <ListItem key={item.Numero}>
                        <ListItemButton
                          sx={{
                            width: "100%",
                            backgroundColor:
                              index % 2 === 0 ? "#F4F6F6 " : "#F2F4F4",
                          }}
                          onClick={() => onClickLista(item)}
                        >
                          {/* Agrega aquí tu ícono */}
                          <ListItemText
                            primary={`Nº:${item.Numero} / ${format(
                              new Date(item.FechaDoc),
                              "dd-MM-yyyy"
                            )} / ${item.Referencia}`}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Grid>
            </Grid>
          </>
        )}
        {/* Mostrar datos Sin seleccionar un items */}
        {bScanResDes && !bMostrarDato && (
          <Grid container sx={{ mt: 1 }} spacing={1}>
            <Grid item xs={3} md={3} sm={3}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextField13L
                  fullWidth
                  inputRef={ScanBarraRef}
                  label="Scan Cód.Barra"
                  color="success"
                  onKeyDown={handleKeyDownCodBarra}
                />
              </Box>
            </Grid>
            <Grid item xs={3} md={3} sm={3}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextField13L
                  fullWidth
                  label="Código"
                  color="success"
                  onKeyDown={handleKeyDownCodBarra}
                />
              </Box>
            </Grid>
            <Grid item xs={6} md={6} sm={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextField13R
                  disabled
                  id="full"
                  label={`N° - Ref.${sReferencia}`}
                  value={iNumero}
                  // InputLabelProps={IPropslabel14px}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TableContainer component={Paper}>
                  <Table aria-label="contacts">
                    <TableHead>
                      <TableRow>
                        <TableCell>Item</TableCell>
                        <TableCell>Nombre</TableCell>
                        <TableCell>Unidad</TableCell>
                        <TableCell>Cantidad</TableCell>
                        <TableCell>Entregado</TableCell>
                        <TableCell>Acciones</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {datadetalle.map((item, index) => (
                        <TableRow key={item.Numero}>
                          <TableCell>{item.Item}</TableCell>
                          <TableCell>
                            {item.Nombre.substring(0, 20).trim()}
                          </TableCell>
                          <TableCell>{item.Unidad}</TableCell>
                          <TableCell>{item.Cantidad}</TableCell>
                          <TableCell>
                            <IconButton edge="start" aria-label="delete">
                              {item.Entregado}
                            </IconButton>
                          </TableCell>
                          <TableCell>H</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            <Grid item xs={12} md={12} sm={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "right",
                }}
              >
                <IconButton onClick={onClickListado}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <ReceiptLongIcon />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <ListAltIcon />
                  </Avatar>
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        )}
        {/* Mostrar datos Ya seleccionado un items */}
        {bScanResDes && bMostrarDato && (
          <Grid container sx={{ p: 1 }} spacing={1}>
            <Grid item xs={6} md={6} sm={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextField13L
                  fullWidth
                  inputRef={ScanBarraRef}
                  label="Scan Cód.Barra"
                  color="success"
                  onKeyDown={handleKeyDownCodBarra}
                  inputProps={IPropsNumerico}
                />
              </Box>
            </Grid>
            <Grid item xs={6} md={6} sm={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextFieldCnt
                  disabled
                  id="full"
                  label={`Pendiente`}
                  value={iMostrarPendiente}
                  InputLabelProps={IPropslabel15px}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={6} md={6} sm={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextField13R
                  disabled
                  id="full"
                  label={`N° - Ref.${sReferencia}`}
                  value={iNumero}
                  // InputLabelProps={IPropslabel14px}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={6} md={6} sm={6}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <CustomTextFieldCnt
                  disabled
                  id="full"
                  label={`Cantidad Stk(${iMostrarStk})`}
                  value={iMostrarCantidad}
                  InputLabelProps={IPropslabel15px}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "center",
                }}
              >
                <TextField
                  disabled
                  id="full"
                  label={`Código ${sMostrarCodigo}`}
                  value={sMostrarDescripcion}
                  fullWidth
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={12} sm={12}>
              <Box
                borderRadius={"8px"}
                sx={{
                  boxShadow: 1,
                  backgroundColor: "#FFFFFF",
                  color: "text.secondary",
                  p: 1,
                  maxWidth: "100%",
                  textAlign: "right",
                }}
              >
                <IconButton onClick={onClickListado}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <ReceiptLongIcon />
                  </Avatar>
                </IconButton>
                <IconButton onClick={onClickVolver}>
                  <Avatar sx={{ backgroundColor: "green" }}>
                    <ListAltIcon />
                  </Avatar>
                </IconButton>
              </Box>
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
};
export default Entregas;
